import React from 'react';
import DeliveryManagementAppListPageContainer from './DeliveryManagementAppListPageContainer';

export class DeliveryManagementAppListPage extends React.Component{
    
    render(){
      return (
        <DeliveryManagementAppListPageContainer {...this.props}/>
      )
    }
}